import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M16.048 15.074L19 18.024l-.975.976-2.951-2.952A6.205 6.205 0 015 11.202 6.205 6.205 0 0111.203 5a6.205 6.205 0 014.845 10.074zm-1.382-.512a4.823 4.823 0 00-3.463-8.184 4.822 4.822 0 00-4.825 4.825 4.823 4.823 0 008.184 3.463l.104-.104z"
      ></path>
    </svg>
  )
}

export default Icon
